import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserInfoModule} from 'app/core/userInfo.module';
import {Observable} from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {


    constructor(
        private _userInfo: UserInfoModule,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const lang = (this._userInfo && this._userInfo.selectedLang && this._userInfo.selectedLang.code) ? this._userInfo.selectedLang.code : 'cs-CZ';
        const modifiedReq = req.clone({
            headers: req.headers.set('App-UI-Selected-Language', `${lang}`),
        });
        return next.handle(modifiedReq);
    }

}

export const LanguageInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: LanguageInterceptor,
    multi: true
};
